export enum FontSizeModeEnum {
  DEFAULT = 'default',
  LARGE = 'large',
  EXTRA_LARGE = 'xlarge',
}
